module.exports = __webpack_public_path__ + "img/car.974e33ef.png";